import { createContext, useContext, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ccc_user") || "null"); }
    catch { return null; }
  });

  function persist(data) {
    localStorage.setItem("ccc_token", data.token);
    localStorage.setItem("ccc_user", JSON.stringify(data.user));
    setUser(data.user);
  }

  const loginAdmin = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
    return data.user;
  };

  const loginCrew = async (username, pin) => {
    const { data } = await api.post("/auth/crew-login", { username, pin });
    persist(data);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ccc_token");
    localStorage.removeItem("ccc_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loginAdmin, loginCrew, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
